export enum TooltipArrowPosition{
  TopRight = "top-right",
  TopCenter = "top-center",
  TopLeft = "top-left",
  BottomLeft = "bottom-left",
  BottomCenter = "bottom-center",
  BottomRight = "bottom-right"
}
